export const usageCharts = [
  {
    title: 'chart1.title',
    field: 'browserUsage',
    data: [
      { label: 'chart1.chrome', field: 'chrome', value: 0 },
      { label: 'chart1.firefox', field: 'firefox', value: 0 },
      { label: 'chart1.safari', field: 'safari', value: 0 },
      { label: 'chart1.other', field: 'other', value: 0 },
      { label: 'chart1.opera', field: 'opera', value: 0 },
    ],
  },
  {
    title: 'chart2.title',
    field: 'devicesUsage',
    data: [
      { label: 'chart2.mobile', field: 'mobile', value: 0 },
      { label: 'chart2.web', field: 'web', value: 0 },
    ],
  },
  {
    title: 'chart3.title',
    field: 'operatingSystemUsage',
    data: [
      { label: 'chart3.ios', field: 'ios', value: 0 },
      { label: 'chart3.other', field: 'other', value: 0 },
      { label: 'chart3.windows', field: 'windows', value: 0 },
    ],
  },
];
